import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { QuestionPayloadType } from "@/common/types/question";

export async function formQuestionList(
  account_id: string,
  form_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/form/${form_id}/question/list${queryString}`,
  );
}

export async function formQuestionShow(
  account_id: string,
  question_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/form/question/${question_id}/show`,
  );
}

export async function formQuestionCreate(
  account_id: string,
  form_id: string,
  payload: QuestionPayloadType,
) {
  const formated = {
    ...payload,
    metadata:
      typeof payload.metadata === "object"
        ? JSON.stringify(payload.metadata)
        : payload.metadata,
  };

  return await clientAxios.post(
    `account/${account_id}/form/${form_id}/question/create`,
    formated,
  );
}

export async function formQuestionUpdate(
  account_id: string,
  item_id: string,
  payload: QuestionPayloadType,
) {
  const formated = {
    ...payload,
    metadata:
      typeof payload.metadata === "object"
        ? JSON.stringify(payload.metadata)
        : payload.metadata,
  };

  return await clientAxios.put(
    `account/${account_id}/form/question/${item_id}/update`,
    formated,
  );
}

export async function formQuestionPatch(
  account_id: string,
  item_id: string,
  payload: Partial<QuestionPayloadType>,
) {
  const formated = {
    ...payload,
    metadata: JSON.stringify(payload.metadata).toString(),
  };

  return await clientAxios.patch(
    `account/${account_id}/form/question/${item_id}/patch`,
    formated,
  );
}

export async function formQuestionDelete(account_id: string, item_id: string) {
  return await clientAxios.del(
    `account/${account_id}/form/question/${item_id}/delete`,
  );
}
